import styled from 'styled-components';
import Banner from './Banner';
import { colorSchema } from 'utils/style';

export default styled(Banner)`
  .banner {
    background: ${colorSchema('white')};
    border-radius: 4px;
    box-shadow: 0 0 20px 0 rgba(207, 211, 217, 0.72);
    bottom: 2rem;
    display: flex;
    left: 2rem;
    padding: 2.6rem;
    position: fixed;
    width: 343px;
    z-index: 9;

    &__close {
      align-items: center;
      background: none;
      border: 0;
      cursor: pointer;
      display: flex;
      justify-content: center;
      position: absolute;
      top: 1.6rem;
      right: 1.6rem;

      svg {
        fill: ${colorSchema('grey700')};
      }
    }
  }
`;
